import "core-js/actual"
import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {Provider} from "react-redux";
import {applyMiddleware, combineReducers, compose, createStore} from "redux";
import thunk from "redux-thunk";
import {BrowserRouter} from "react-router-dom";
import {CookiesProvider} from "react-cookie";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import 'antd/dist/antd.css';

import testReducer from './store/reducers/personalAccount/test'
import departmentsReducer from "./store/reducers/departments";
import employeesReducer from "./store/reducers/employee";
import phonebookReducer from "./store/reducers/phonebookList";
import studiesReducer from "./store/reducers/studies";
import scheduleReducer from "./store/reducers/schedule";
import departmentInfoReducer from "./store/reducers/departmentInfo";
import authReducer from "./store/reducers/auth";
import markSheetRequestsReducer from "./store/reducers/personalAccount/markSheetRequests";
import markSheetRequestsDialogReducer from "./store/reducers/personalAccount/markSheetRequestsDialog";
import markbookReducer from "./store/reducers/personalAccount/markbook";
import personalRatingReducer from "./store/reducers/personalAccount/personalRating";
import profileReducer from "./store/reducers/personalAccount/profile";
import groupInfoReducer from "./store/reducers/personalAccount/groupInfo";
import announcementReducer from "./store/reducers/personalAccount/announcement";
import socialAndResearchWorkReducer from "./store/reducers/personalAccount/socialAndResearchWork";
import profilingReducer from "./store/reducers/personalAccount/profiling";
import certificateRequestsReducer from "./store/reducers/personalAccount/certificateRequests";
import personalInfoReducer from './store/reducers/personalAccount/personalInformation'
import diplomaReducer from "./store/reducers/personalAccount/diploma";
import practiceReducer from "./store/reducers/personalAccount/practice";
import dormitory from "./store/reducers/personalAccount/dormitory";
import omissions from "./store/reducers/personalAccount/omissions"
import libraryBooksReducer from "./store/reducers/personalAccount/libraryBooks";
import libraryNewsReducer from "./store/reducers/personalAccount/libraryNews";
import studentsListReducer from "./store/reducers/studentsList"
import lmsApplicationsReducer from "./store/reducers/personalAccount/lmsApplications";
import messageReducer from "./store/reducers/message"
import headmanReducer from "./store/reducers/personalAccount/headman"
import {setupInterceptors} from "./services/authService";
import generalReducer from './store/reducers/general'
import notificationsReducer from "./store/reducers/notifications";
import {ConfigProvider} from 'antd';
import ru_RU from 'antd/es/locale/ru_RU';
import gsap from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";


const rootReducer = combineReducers({
  departments: departmentsReducer,
  employees: employeesReducer,
  phonebookList: phonebookReducer,
  studies: studiesReducer,
  schedule: scheduleReducer,
  departmentInfo: departmentInfoReducer,
  auth: authReducer,
  markSheetRequests: markSheetRequestsReducer,
  markSheetRequestsDialog: markSheetRequestsDialogReducer,
  markbook: markbookReducer,
  personalRating: personalRatingReducer,
  profile: profileReducer,
  groupInfo: groupInfoReducer,
  test: testReducer,
  announcement: announcementReducer,
  socialAndResearchWork: socialAndResearchWorkReducer,
  profiling: profilingReducer,
  certificateRequests: certificateRequestsReducer,
  diploma: diplomaReducer,
  practice: practiceReducer,
  personalInfo: personalInfoReducer,
  dormitory: dormitory,
  libraryBooks: libraryBooksReducer,
  libraryNews: libraryNewsReducer,
  studentsList: studentsListReducer,
  lmsApplications: lmsApplicationsReducer,
  omissions: omissions,
  message: messageReducer,
  headman: headmanReducer,
  general: generalReducer,
  notifications: notificationsReducer,
});

let composeEnhancers = null;
if (process.env.NODE_ENV === "development") {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
} else {
  composeEnhancers = compose;
}
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

setupInterceptors(store);

gsap.registerPlugin(ScrollTrigger);

ReactDOM.render(
    <CookiesProvider>
      <Provider store={store}>
        <BrowserRouter>
          <ConfigProvider locale={ru_RU}>
            <App />
          </ConfigProvider>
        </BrowserRouter>
      </Provider>
    </CookiesProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
